import ApiClient from './ApiClient';

export default class MetaApi extends ApiClient {
  /**
   * Сео для главной страницы
   * @param dealType
   * @param realtyType
   * @param regionId
   * @returns {*}
   */
  fetchMetaHome (dealType, realtyType, regionId) {
    const filter = { dealType, realtyType };
    return this.get(`${this.prefix}seo/meta/mainPage/${regionId}`, filter);
  }
}



// WEBPACK FOOTER //
// ./src/api/MetaApi.js